<template>
  <div class="content">
    <NavBar :navtitle="navtitle" :navBlock="navBlock"></NavBar>
    <div class="paddingContent">
      <el-row class="ListMenu">
        <el-col :span="24">
          <el-form ref="form" :model="listMenuForm" class="searchForm">
            <el-form-item label="用戶昵稱" class="searchItem">
              <el-input v-model="listMenuForm.nickname"></el-input>
            </el-form-item>
            <el-form-item label="用戶賬號" class="searchItem ">
              <el-input v-model="listMenuForm.username"></el-input>
            </el-form-item>
            <el-form-item label="狀態" class="searchItem ">
              <el-select v-model="listMenuForm.status">
                <el-option label="審核中" value="2"></el-option>
                <el-option label="違規評論" value="3"></el-option>
                <el-option label="已解禁" value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <div class="MenuBtnWrap">
        <div class="btn" @click="search">查詢</div>
        <div class="btn borderBtn" @click="reset">重置</div>
      </div>
      <div class="tableWrap">
        <el-table :data="userInfoList" style="width:100%;">
          <template slot="empty">
            <div class="no-data-container">
              <img
                src="@/assets/images/common/no_data.png"
                alt="暂无数据"
                :style="{ width: '244px', height: '139px' }"
              />
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in userInfoTable"
            :key="index"
            :prop="item.prop"
            :label="item.label"
          >
            <template slot-scope="scope">
              <div v-if="!scope.row[item.prop] && scope.row[item.prop] !== 0">
                -
              </div>

              <div v-else-if="item.prop === 'list'">
                <span
                  v-for="(item, index) in scope.row[item.prop]"
                  :key="index"
                >
                  {{ item.nickname }}
                </span>
              </div>
              <div v-else-if="item.prop === 'status'">
                {{scope.row[item.prop] == 2 ? "審核中" : scope.row[item.prop] == 3 ? "違規評論" : "已解禁"}}
              </div>
              <div v-else>{{ scope.row[item.prop] }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <!-- v-if="scope.row.authorizationCode != '審核不通過'"  -->
              <el-button
														 :disabled="scope.row.status == 3"
														 @click="toHide(scope.row, 'weigui')" type="text"
                >違規</el-button
              >
              <el-button
														:disabled="scope.row.status == 4"
														 @click="toHide(scope.row, 'jiejin')" type="text"
                >解禁</el-button
              >
              <!-- <el-button v-else type="text" style="color:#eee;">查看詳情</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination
          class="paging fr"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count="5"
          layout="prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";
import { throttle } from "../../directives/limit";
export default {
  data() {
    return {
      navBlock: "簽到",
      navtitle: "評論列表",
      userInfoList: [],
      listMenuForm: {
        status: "",
        username: "",
        nickname: ""
      },
      userInfoTable: [
        {
          prop: "email",
          label: "用戶賬號"
        },

        {
          prop: "nickname",
          label: "用戶昵稱"
        },
        {
          prop: "content",
          label: "評論内容"
        },
        {
          prop: "createTime",
          label: "評論時間"
        },
        {
          prop: "complaintType",
          label: "投訴類型"
        },
        {
          prop: "list",
          label: "投訴人"
        },
        {
          prop: "complainsCount",
          label: "投訴次數"
        },
        {
          prop: "status",
          label: "狀態"
        },
        {
          prop: "complaintTime",
          label: "投訴時間"
        }
      ],
      currentPage: 1,
      total: 10,
      dialogVisible: false,
    };
  },
  created() {
    let _this = this;
    _this.getUserInfoList();
  },
  activated() {
    let _this = this;
    _this.getUserInfoList();
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    // 获取用户列表
    getUserInfoList() {
      let _this = this;
      _this
        .$get(
          `/request/earth/sign/feedback/complaint/list?page=${_this.currentPage}&size=10&nickname=${_this.listMenuForm.nickname}&username=${_this.listMenuForm.username}&status=${_this.listMenuForm.status}`,
          {},
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          if (res.code === "00000") {
            _this.total = res.data.allRow;
            res.data.list.forEach(v => {
              v.complaintType =
                v.complaintType == 1
                  ? "仇恨言論或人身攻擊"
                  : v.complaintType == 2
                  ? "垃圾或廣告訊息"
                  : v.complaintType == 3
                  ? "詐騙或不實信息"
                  : v.complaintType == 4
                  ? "色情訊息"
                  : v.complaintType == 5
                  ? "有害或危險內容"
                  : "其他";
              v.complaintTime = _this.$getTime(v.complaintTime);
              v.createTime = _this.$getTime(v.createTime);
            });
            _this.userInfoList = res.data.list;
          } else {
            _this.$propMessage(res.message, "error");
          }
        });
    },
    // 分页
    handleCurrentChange(val) {
      let _this = this;
      _this.currentPage = val;
      _this.getUserInfoList();
    },
    // 查询
    search() {
      let _this = this;
      _this.currentPage = 1;
      _this.getUserInfoList();
    },
    // 重置
    reset() {
      let _this = this;
      _this.listMenuForm = {
        status: "",
        nickname: "",
        username: ""
      };
      _this.currentPage = 1;
      _this.getUserInfoList();
    },
    //隱藏
    toHide:throttle(
      function() { 
        return true
      },
      function(e,sort) { 
         let _this = this;
          _this.$message.closeAll();
      let status;
      if (sort == "weigui") {
        status = 3;
      } else {
        status = 4;
      }

      const param = {
        status,
        id: e.id
      };
      _this
        .$post(
          `/request/earth/sign/feedback/complaint/operate`,
          param,
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          _this.dialogVisible = true;
          if (res.code === "00000") {
            _this.dialogVisible = false;
            this.$message({
              message: "操作成功",
              type: "success"
            });
          
            _this.getUserInfoList();
          } else {
            _this.dialogVisible = false;
            _this.$propMessage(res.message, "error");
          }
        });
      },2000
    )
     
    
  },
  components: {
    NavBar,
    DiaMess
  }
};
</script>

<style lang="less" scoped>
.content {
  .paddingContent {
    width: 100%;
    .ListMenu {
      display: flex;
    }
    .tableWrap {
      width: 100%;
      margin-top: 0.4rem;
      height: calc(100% - 152px);
      overflow: auto;
      word-break: break-all;

      @media (max-width: 768px) {
        height: calc(100% - 92px);
      }

      @media (max-width: 420px) {
        height: calc(100% - 112px);
      }
    }
  }
}
@media screen and (min-width: 769px) {
  .ListMenu {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .searchForm {
      flex: 1;
      display: flex;
      justify-content: flex-start;
      // .searchItem{
      //     flex: 1;
      // }
    }
    .MenuBtnWrap {
      flex: 1;
    }
  }
}
/deep/ .el-table .cell div {
  //超出一行省略號顯示
  word-wrap: break-word;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>



// WEBPACK FOOTER //
// src/pages/sign/commentList.vue